import http from '@/http';
import store from '../store';

export default class ProcessoService {

	findTiposSelecoes() {
		return http.get('/selecao/tipos-selecoes').then(res => res.data);
    }

	getProcessos() {
		return http.get('selecao/todas').then(res => res.data);
    }

	atualizarListaProcessos() {
		this.getProcessos().then(resposta => {
			let grupoProcessoSelecao = [];
			let processoSelecionado  = store.state.processoSelecionado ? store.state.processoSelecionado : null;
			// console.log("processo recuperado", store.state.processoSelecionado);
			grupoProcessoSelecao.push({'nomeCompleto': 'Em Andamento', 'grupo':true});
			resposta.filter( s => !s.finalizado ).forEach( item => {
				grupoProcessoSelecao.push(item);
				if (!processoSelecionado) {
					processoSelecionado = item;
					store.commit('setProcessoSelecionado', processoSelecionado);
				}
			});
			grupoProcessoSelecao.push({'nomeCompleto': 'Finalizado', 'grupo':true});
			resposta.filter( s => s.finalizado ).forEach( item => {
				grupoProcessoSelecao.push(item)
				if (!processoSelecionado) {
					processoSelecionado = item;
					store.commit('setProcessoSelecionado', processoSelecionado);
				}
			});
			// console.log("setando processo", processoSelecionado);
			store.commit('setListaProcessos', grupoProcessoSelecao);
		});
    }

	getProcesso(id) {
		return http.get('selecao/' + id).then(res => res.data);
    }

	getProcessoAtivo() {
		return http.get("selecao")
	  }

	update(processo) {
		let processoDTO = {
			'coeficienteMinimo': processo.coeficienteMinimo,
			'datHoraInicioInscricao': processo.datHoraInicioInscricao + ' 00:00',
			'datHoraFimInscricao': processo.datHoraFimInscricao + ' 23:59',
			'descricao': processo.descricao,
			'estadoSelecao': processo.estadoSelecao.cod,
			'nome': processo.nome,
			'dataHoraInicioProva': processo.dataHoraInicioProva,
			'dataHoraFimProva': processo.dataHoraFimProva,
			'turnoProva': processo.turnoProva.name,
			'tipoSelecao': processo.tipoSelecao.cod,
		  };
		return http.put(`selecao/${processo.id}`, processoDTO).then(res => {
			this.atualizarListaProcessos();
			return res.data;
		});
    }

	liberarCartao(processo, usuarioId) {
		return http.put(`selecao/cartao/${processo.id}/${usuarioId}`).then(res => res.data);
    }

	getInformacaoLiberacao() {
		return http.get(`selecao/liberacao/cartao/informacao`).then(res => res.data);
	}

	gerarResutadoSelecaoEstagio(processo) {
		return http.put(`selecao/gerar-resultado/${processo.id}`).then(res => res.data);
    }

	create(processo) {
		processo.datHoraInicioInscricao += ' 00:00';
		processo.datHoraFimInscricao += ' 23:59';
		return http.post('selecao', processo).then(res => {
			this.atualizarListaProcessos();
			return res.data;
		});
    }

	delete(processo) {
		console.log('create ...');
		return http.delete(`selecao/${processo.id}`).then(res => res.data);
    }

	listarResultado(idProcesso) {
		return http.get(`selecao/resultado/listar/${idProcesso}`).then(res => res.data);
	}

	listarResultadoArea(idSelecaoArea) {
		return http.get(`selecao/resultado/listar/area/${idSelecaoArea}`).then(res => res.data);
	}

	gerarResultado(idProcesso) {
		return http.put(`selecao/resultado/gerar/${idProcesso}`).then(res => res.data);
	}

	processaResultadoGabarito(idProcesso) {
		return http.post(`selecao/resultado/processarrespostas/${idProcesso}`).then(res => res.data);
	}

	exportarResultadoContato(idProcesso, tipo, tituloArquivo) {
		var url = `selecao/resultado/contato/exportar/${idProcesso}/${tipo}`;

		this.exportar(url, tituloArquivo);
	}

	exportarResultado(idProcesso, tipo, tituloArquivo) {
		var url = `selecao/resultado/exportar/${idProcesso}/${tipo}`;

		this.exportar(url, tituloArquivo);
	}

	exportar(url, tituloArquivo) {
		// var url = `selecao/resultado/exportar/${idProcesso}/${tipo}`;

		return http({url: url,
				method: "GET",
				responseType: "blob",
				headers: { 'Content-Type': 'text/plain;charset=UTF-8',}})
			.then((reponse) => {
				const fileBlob = new Blob([reponse.data]);
				const fileUrl = window.URL.createObjectURL(fileBlob);
				const fileLink = document.createElement("a");
				fileLink.href = fileUrl;

				fileLink.setAttribute("download",`${tituloArquivo}.csv`);
				fileLink.setAttribute("target", "_blank");

				document.body.appendChild(fileLink);

				fileLink.click();
			});
	}

	exportarCartoesUfam(idProcessoSeletivo, tituloArquivo) {

		var url = `selecao/exportar/cartoes-ufam/${idProcessoSeletivo}`;

		return http({ 	url: url,
						method: "GET",
						responseType: "blob",
						headers: {	'Content-Type': 'octet-stream;charset=UTF-8',
									'Accept': 'application/pdf'}
		  }).then((reponse) => {
		  	const fileBlob = new Blob([reponse.data]);
		  	const fileUrl = window.URL.createObjectURL(fileBlob);
		  	const fileLink = document.createElement("a");
		  	fileLink.href = fileUrl;

		  	fileLink.setAttribute("download",`${tituloArquivo}.pdf`);
		  	fileLink.setAttribute("target", "_blank");

		  	document.body.appendChild(fileLink);

		  	fileLink.click();
		});
	}

}
